import type { ExperimentConfig } from '../@types'

const bPaywall = () =>
	import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_eu_sales_tax/web_eu_sales_tax__b')
const cPaywall = () =>
	import(/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_eu_sales_tax/web_eu_sales_tax__c')

const config: ExperimentConfig[] = [
	{
		// B — /result_complete?safe&mock-data&utm_source=FB&country=DE&area=<appArea>&exp=web_eu_sales_tax~1
		female: { paywall: { experiment: bPaywall } },
		'female-water-fasting': { paywall: { experiment: bPaywall } },
		'activity-female-walking': { paywall: { experiment: bPaywall } },
		'activity-female-tai-chi-walking-v2': { paywall: { experiment: bPaywall } },
	},
	{
		// C — /result_complete?safe&mock-data&utm_source=FB&country=DE&area=<appArea>&exp=web_eu_sales_tax~2
		female: { paywall: { experiment: cPaywall } },
		'female-water-fasting': { paywall: { experiment: cPaywall } },
		'activity-female-walking': { paywall: { experiment: cPaywall } },
		'activity-female-tai-chi-walking-v2': { paywall: { experiment: cPaywall } },
	},
]

export default config
